import { useMemo, useCallback } from 'react';
import { useDialogState } from './useDialogState';

export type DialogCancelProps = {
  openCancel: boolean;
  onNoteDiscard: () => void;
  discardNote: () => void;
  closeCancelDialog: () => void;
  isValidForm: boolean;
  isFormDirty: boolean;
};

export type UseDialogCancelActionProps = {
  onClose: () => void;
  isFormDirty: boolean;
  isValidForm: boolean;
  loading?: boolean;
};
export const useDialogCancelAction = ({
  onClose,
  isFormDirty,
  isValidForm,
  loading
}: UseDialogCancelActionProps): DialogCancelProps => {
  const {
    open: openCancel,
    openDialog: openCancelDialog,
    closeDialog: closeCancelDialog
  } = useDialogState();

  const onNoteDiscard = useCallback(() => {
    if (loading) {
      return;
    }
    if (isFormDirty) {
      openCancelDialog();
      return;
    }
    onClose();
  }, [isFormDirty, onClose, openCancelDialog, loading]);

  const discardNote = useCallback(() => {
    closeCancelDialog();
    onClose();
  }, [closeCancelDialog, onClose]);

  return useMemo(
    () => ({
      openCancel,
      onNoteDiscard,
      discardNote,
      closeCancelDialog,
      isFormDirty,
      isValidForm
    }),
    [
      openCancel,
      onNoteDiscard,
      discardNote,
      closeCancelDialog,
      isFormDirty,
      isValidForm
    ]
  );
};
